export default {
  isSidebarOpen: state => state.sidebarOpen,
}
